module.exports = __webpack_public_path__ + "img/experiments_11_hr_u1_v1.4fbbdcc1.png";